
<div class="main-container background-img" >
  <div class="containter-fluid pl-3 pl-md-5 pt-3">
    <div class="row">
      <div class="col col-md-8 offset-md-1" *ngFor="let advisor of advisor">
        <a [routerLink]="['/', this.translate.currentLang, 'advisor', advisor.name]" (click)="quiz.answers = []">
          <img [src]="logo | translate" class="ipc-logo"
            alt="ipc logo">
        </a>
      </div>
       <div class="col col-md-2 col-lang my-auto" *ngFor="let advisor of advisor">
        <label for="" *ngIf="advisor.MultiLang === true">
          <button class="lang-btn" (click)="changeLang('en')">EN</button>
          <button class="lang-btn" (click)="changeLang('fr')">FR</button>
        </label>
      </div> 
    </div>
  </div>
  <div class="container-fluid p-3 p-md-5 overflow-auto ">
    <div class="row pt-0 pt-md-5">
      <div class="col-md-8 col-xl-5 col-lg-8 offset-md-1">
        <h1 class="mt-4 mb-0 home-title" [innerHTML]="title | translate"></h1>
        <p class="subheading">{{ subTitle | translate}}</p>
        <P class="paragraph-text">{{ description | translate}}</P>
      </div>
      <div class="col-md-5">
      </div>
    </div> 
    <div class="row pt-4">
      <div class="col-md-5 offset-md-1" *ngFor="let advisor of advisor">
        <button class="btn btn-outline-primary" [routerLink]="['/',this.translate.currentLang, 'advisor', advisor.name, 'question', '0']" >{{ startBtn | translate}}</button>
      </div>
    </div>
  </div>
</div>
<router-outlet></router-outlet>
